import PlanCard from "./PlanCard";

const PaymentPlans = ({
  plans,
  selectedPlan,
  setSelectedPlan,
  expandedPlan,
  setExpandedPlan,
  loading
}) => {
  if (loading)
    return (
      <div className="text-center py-3">
        <div className="spinner-border text-primary"></div>
      </div>
    );

  return (
    <div className="card shadow border-0 rounded-3 p-4 my-2">
      <div className="accordion">
        {plans.map(plan => (
          <PlanCard
            key={plan.id}
            plan={plan}
            selectedPlan={selectedPlan}
            expandedPlan={expandedPlan}
            onSelect={setSelectedPlan}
            onExpand={setExpandedPlan}
          />
        ))}
      </div>
    </div>
  );
};

export default PaymentPlans;
